import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "queryType",
    "anno",
    "categoria",
    "sesso",
    "millesimo",
    "matchedTeams",
    "annoRequired",
    "categoriaRequired",
    "sessoRequired",
    "millesimoRequired",
    "annoWrapper",
    "categoriaWrapper",
    "sessoWrapper",
    "millesimoWrapper",
    "matchedTeamsWrapper"
  ]

  connect() {
    this.update()
  }

  update() {
    const requiredFields = {
      racers_with_teams: ["anno", "categoria"],
      racers_by_sex_and_birth_year: ["sesso", "millesimo"]
    }[this.queryTypeTarget.value] || []

    this.fieldNames.forEach((fieldName) => {
      const required = requiredFields.includes(fieldName)
      this[`${fieldName}Target`].required = required
      this[`${fieldName}Target`].setAttribute("aria-required", required)
      this[`${fieldName}RequiredTarget`].classList.toggle("d-none", !required)
      this[`${fieldName}WrapperTarget`].classList.toggle("opacity-50", !required)
    })

    this.matchedTeamsWrapperTarget.classList.toggle(
      "opacity-50",
      this.queryTypeTarget.value !== "racers_with_teams"
    )
  }

  get fieldNames() {
    return ["anno", "categoria", "sesso", "millesimo"]
  }
}
